import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  plannedScores: [],
  plannedScore: {},
};

export const getPlannedScores = createAsyncThunk(
  'plannedScores/getPlannedScores',
  async query => {
    const { data } = await api.get('/tasks/planned-scores', query);

    return data;
  },
);

export const getPlannedScore = createAsyncThunk(
  'plannedScores/getPlannedScore',
  async id => {
    const { data } = await api.get(`/tasks/planned-scores/${id}`);

    return data;
  },
);

export const addPlannedScore = createAsyncThunk(
  'plannedScores/addPlannedScore',
  async formData => {
    const { data } = await api.post('/tasks/planned-scores', formData);

    return data;
  },
);

export const editPlannedScore = createAsyncThunk(
  'plannedScores/editPlannedScore',
  async ({ id, data: formData }) => {
    const { data } = await api.put(`/tasks/planned-scores/${id}`, formData);

    return data;
  },
);

export const deletePlannedScore = createAsyncThunk(
  'plannedScores/deletePlannedScore',
  async id => {
    await api.delete(`/tasks/planned-scores/${id}`);

    return id;
  },
);

const plannedScores = createSlice({
  name: 'plannedScores',

  initialState,

  reducers: {
    clearPlannedScores: draft => {
      draft.plannedScores = initialState.plannedScores;
    },

    clearPlannedScore: draft => {
      draft.plannedScore = initialState.plannedScore;
    },
  },

  extraReducers: builder => {
    builder.addCase(getPlannedScores.fulfilled, (draft, { payload }) => {
      draft.plannedScores = payload;
    });

    builder.addCase(getPlannedScore.fulfilled, (draft, { payload }) => {
      draft.plannedScore = payload;
    });

    builder.addCase(addPlannedScore.fulfilled, (draft, { payload }) => {
      draft.plannedScores.push(payload);
    });

    builder.addCase(editPlannedScore.fulfilled, (draft, { payload }) => {
      const index = draft.plannedScores.findIndex(el => el.id === payload.id);

      if (index !== -1) {
        draft.plannedScores[index] = payload;
      }
    });

    builder.addCase(deletePlannedScore.fulfilled, (draft, { payload }) => {
      draft.plannedScores = draft.plannedScores.filter(el => el.id !== payload);
    });

    builder.addMatcher(
      isAnyOf(
        getPlannedScores.rejected,
        getPlannedScore.rejected,
        addPlannedScore.rejected,
        editPlannedScore.rejected,
        deletePlannedScore.rejected,
      ),
      (_draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearPlannedScores, clearPlannedScore } = plannedScores.actions;

export default plannedScores.reducer;
